module.exports = __webpack_public_path__ + "img/image00001-min.80cdd515.jpeg";